import { createFileRoute } from '@tanstack/react-router'

import { TeaMachinesPanel } from '@/components/tea-machines/tea-machines-panel'

export const Route = createFileRoute('/_app/_authed/_sidebar/tea-machines')({
    component: TeaMachinesPage,
})

function TeaMachinesPage() {
    return <TeaMachinesPanel />
}
